<script setup lang="ts">
import { Archive } from '@/components';
import { useFormStore } from '@/stores/forms';
import { onMounted } from 'vue';

const formStore = useFormStore();

onMounted(async () => {
  if (!formStore.formList.length) {
    await formStore.getStudyForms();
  }
});

</script>

<template>
  <div class="activity-container" v-if="formStore.formList.length > 0">
    <Archive />
  </div>
</template>

<style scoped lang="scss">
.activity-container {
  height: 100%;
}
</style>
